import { Labelfile } from '@app/core/model/driver360.model';
import { IDriver360Service } from '../interface/IDriver360Service';

export class MockDriver360Service implements IDriver360Service {
  constructor() {}

  getLabelfile(definition: string): Promise<Labelfile[]> {
    const promise = new Promise<Labelfile[]>((resolve, reject) => {
      resolve([]);
    });
    return promise;
  }
}
